module.exports = __webpack_public_path__ + "img/file.c4ea85e4.svg";